import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import AIEvaluationResultHistory from './AIEvaluationResultHistory'
import { getAiEvaluationHistory } from '../../redux/actions/aiEvaluation'
import { doneLoading, startLoading } from '../../utils/loading'
import ErrorWidget from '../errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'

export default function AIEvaluationResultHistoryWidget({ shaded, hideWhenNoData }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [isHide, setIsHide] = useState()

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    }
  }, [])

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    try {
      const response = await getAiEvaluationHistory(projectId)
      if (response) {
        if (hideWhenNoData && (response.datas || []).length < 1) {
          setIsHide(true)
        } else {
          setSchema(response)
        }
      } else {
        setError({})
      }
    } catch (e) {
      // console.error('error => ', e)
      setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {!isHide && (
        <Panel
          header={schema?.header || 'ประวัติการประเมินคุณภาพโครงการ'}
          shaded={shaded}
          bordered
          collapsible
          defaultExpanded
          style={{ marginTop: 10 }}
        >
          {error ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '1.2rem', color: '#fb8a81', fontWeight: 'bold' }}>
                {error.errorMessage || DEFAULT_ERR_MSG}
              </p>
              <span>Error Code : {error.statusCode || 500}</span>
            </div>
          ) : !schema || isLoading ? (
            <PanalLoadingTemplate />
          ) : (
            <AIEvaluationResultHistory schema={schema} />
          )}
        </Panel>
      )}
    </>
  )
}
